module.exports = __webpack_public_path__ + "static/media/trybotics-logo2.edae1848.jpg";